import { documentApi } from "@api/documents";
import { RJSFESSelector } from "@forms/rjsf/widgets/RJSFESSelector";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Header } from "semantic-ui-react";

/**
 * React JSONSchema Form widget to search and retrieve Documents.
 */
export class RJSFReferencedDocument extends Component {
  responseSerializer = (record) => {
    const {
      edition,
      pid,
      publicationYear,
      document_type: documentType,
      title,
    } = record.metadata;

    const descriptions = [];
    edition && descriptions.push(`Edition: ${edition}`);
    publicationYear && descriptions.push(`Year: ${publicationYear}`);
    descriptions.push(`Type: ${documentType}`);
    descriptions.push(`PID: ${pid}`);

    return {
      key: pid,
      value: pid,
      text: title,
      content: (
        <Header
          as="h5"
          content={title}
          subheader={descriptions.join(" - ")}
          className="rjsf-reference"
        />
      ),
    };
  };

  /**
   * Enhanced query method that filters out weeded-out documents
   */
  query = async (searchQuery) => {
    // Add filter to exclude weeded-out documents
    const filteredQuery = this.addWeedOutFilter(searchQuery);
    return await documentApi.list(filteredQuery);
  };

  /**
   * Add weed-out filter to the search query
   */
  addWeedOutFilter = (searchQuery) => {
    // If searchQuery is empty or just whitespace, create a basic filter
    if (!searchQuery || searchQuery.trim() === "") {
      return "-weed_out:true AND -metadata.weed_out:true";
    }

    // Add the weed-out filter to existing query
    return `(${searchQuery}) AND -weed_out:true AND -metadata.weed_out:true`;
  };

  /**
   * Enhanced apiQuery method for the RJSFESSelector
   */
  apiQuery = async (searchQuery) => {
    const filteredQuery = this.addWeedOutFilter(searchQuery);
    return await documentApi.list(filteredQuery);
  };

  /**
   * Enhanced apiGetByValue method that checks if document is weeded out
   */
  apiGetByValue = async (value) => {
    try {
      const response = await documentApi.get(value);
      const document = response.data;

      // Check if document is weeded out
      const isWeedOut = document.metadata?.weed_out || document.weed_out;

      if (isWeedOut) {
        // Return null or throw error for weeded out documents
        console.warn(
          `Document ${value} is weeded out and should not be selectable`
        );
        return null;
      }

      return document;
    } catch (error) {
      console.error(`Error fetching document ${value}:`, error);
      throw error;
    }
  };

  render() {
    const { options } = this.props;
    return (
      <RJSFESSelector
        {...this.props}
        options={{
          apiGetByValue: this.apiGetByValue,
          apiGetByValueResponseSerializer: this.responseSerializer,
          apiQuery: this.apiQuery,
          apiQueryResponseSerializer: this.responseSerializer,
          ...options,
        }}
      />
    );
  }
}

RJSFReferencedDocument.propTypes = {
  options: PropTypes.object,
};

RJSFReferencedDocument.defaultProps = {
  options: {},
};
